import * as React from "react";
import { I18n } from "react-redux-i18n";
import { FormControl } from "@common/components/form-control";

import { getTestAttributes } from "@common/utils/tests";
import { Flex } from "@common/components/Flex";
import TreeDropdown from "@common/components/TreeDropdown";
import { MODULE_NAME } from "@modules/individuals";
import { FolderListDto } from "@common/dto/folder/list-dto";

import "./move-to-new-pedigree.styles.scss";


type NewPedigreeProps = {
  folders: FolderListDto[];
  pedigreeName: string;
  folderId?: number;
  onFolderIdChange: (folderId: number) => void;
  onPedigreeNameChange: (value: string) => void;
};

export const MoveToNewPedigree = (props: NewPedigreeProps) => {

  const handlePedigreeNameChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      props.onPedigreeNameChange(e.target.value);
    },
    [props.onPedigreeNameChange]
  );

  return (
    <>
      <Flex alignItems="center" className="MoveToNewPedigree__field">
        <label
          className="MoveToNewPedigree__name__label"
          htmlFor={
            getTestAttributes({
              id: "ind-move-exist-ped-wnd-ped-name",
            }).id
          }
          {...getTestAttributes({
            id: "ped-name-lbl",
          })}
        >
          {I18n.t("Pedigree Name")}:
        </label>
        <FormControl
          className="MoveToNewPedigree__name__input"
          value={props.pedigreeName}
          {...getTestAttributes({
            id: "ind-move-exist-ped-wnd-ped-name",
          })}
          onChange={handlePedigreeNameChange}
        />
      </Flex>
      <Flex alignItems="center" className="MoveToNewPedigree__field">
        <label
          className="MoveToNewPedigree__name__label"
          htmlFor={getTestAttributes({ id: "ped-name-lbl" }).id}
          {...getTestAttributes({
            id: "lbl-folder-settings-fld-name",
          })}
        >
          {I18n.t("Pedigree Folder")}:
        </label>
        <div className="MoveToNewPedigree__folders__container">
          <TreeDropdown
            className="MoveToNewPedigree__folders"
            items={props.folders}
            value={props.folderId}
            onChange={props.onFolderIdChange}
            showFolderIcon={true}
            {...getTestAttributes(MODULE_NAME, "pedigree-folder", "select")}
          />
        </div>
      </Flex>
    </>
  );
};
